export { default } from './Skeleton';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/lab/esm/Skeleton/index.js
// module id = 1683
// module chunks = 121